import { render } from "./RiClipboard.vue?vue&type=template&id=4c6ea599"
import script from "./RiClipboard.vue?vue&type=script&lang=js"
export * from "./RiClipboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiClipboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c6ea599"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c6ea599', __exports__)) {
    api.reload('4c6ea599', __exports__)
  }
  
  module.hot.accept("./RiClipboard.vue?vue&type=template&id=4c6ea599", () => {
    api.rerender('4c6ea599', render)
  })

}


export default __exports__